import { registerPlugin } from "@capacitor/core";

export const YouthCampAppPlugin: {
  /**
   * Add a listener
   */
  addListener(
    eventName: "deviceToken",
    callback: (deviceToken: string) => void
  ): void;

  /**
   * Register for push notification
   */
  registerPushNotifications(): Promise<void>;
} = registerPlugin("YouthCampAppPlugin");
